import { newGatewayUrl } from '@/constant';
import request from '@hb/sharp-request';
import { LegalConstract } from './type';

export const getLegalConstract = (): Promise<LegalConstract> => request.postGate(
  'f.loan.agreement.log',
  {},
  { baseURL: newGatewayUrl },
);
